import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function TruthBridge() {
  return <section className="py-24 bg-cream-50 text-navy-900 relative overflow-hidden" data-id="element-224">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-225">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="space-y-8" data-id="element-226">
          <div className="w-24 h-1 bg-gold-500 mx-auto rounded-full mb-8" data-id="element-227" />

          <h2 className="text-3xl md:text-5xl font-bold font-serif text-navy-900 leading-tight" data-id="element-228">
            Aquí va la verdad{' '}
            <span className="text-gold-600 italic" data-id="element-229">(sin azúcar)</span>
          </h2>

          <p className="text-xl md:text-2xl font-medium text-navy-800/90 max-w-2xl mx-auto leading-relaxed" data-id="element-230">
            Comprar casa no falla por el precio. <br data-id="element-231" />
            <span className="text-red-700 font-bold" data-id="element-232">
              Falla por flujo de efectivo mal entendido.
            </span>
          </p>

          <div className="grid md:grid-cols-2 gap-8 text-left mt-12" data-id="element-233">
            <div className="bg-white p-6 rounded-xl shadow-sm border border-cream-200" data-id="element-234">
              <h3 className="font-bold text-lg mb-3 text-navy-900" data-id="element-235">
                Por qué los videos no ayudan
              </h3>
              <p className="text-navy-800/80" data-id="element-236">
                Videos y blogs explican términos, pero no traducen tu Loan
                Estimate y Closing Disclosure a un plan de control. Te dan
                definiciones, no herramientas.
              </p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm border border-cream-200" data-id="element-237">
              <h3 className="font-bold text-lg mb-3 text-navy-900" data-id="element-238">
                La trampa del "Depende"
              </h3>
              <p className="text-navy-800/80" data-id="element-239">
                Agentes y lenders dicen "depende" porque es la respuesta segura
                para ellos. Pero tú te quedas sin protocolo ni lenguaje para
                exigir claridad.
              </p>
            </div>
          </div>

          <div className="bg-navy-900 text-cream-50 p-8 rounded-2xl shadow-xl mt-12 relative overflow-hidden" data-id="element-240">
            <Quote className="absolute top-4 left-4 w-12 h-12 text-gold-500/20 transform -scale-x-100" data-id="element-241" />
            <p className="text-lg md:text-xl font-serif italic relative z-10" data-id="element-242">
              "No te preocupes" es una red flag. <br data-id="element-243" />
              Aquí tienes qué pedir en su lugar.
            </p>
          </div>

          <p className="text-lg text-navy-800/80 max-w-2xl mx-auto pt-4" data-id="element-244">
            La solución no es otro video de 17 minutos. La solución es un
            sistema que convierta tus documentos (LE/CD) en decisiones simples.
          </p>
        </motion.div>
      </div>
    </section>;
}